import React from "react";

interface FilaTabla {
  nombre_categoria?: string;
  grupo?: string;
  puntos: number;
  PJ: number; PG: number; PE: number; PP: number;
  GF: number; GC: number; DG: number;
}

interface Props {
  filas: FilaTabla[];
  mostrarNombre?: boolean;
}

export default function TablaCategoriaTorneo({ filas, mostrarNombre = true }: Props) {
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm text-left">
        <thead>
          <tr className="bg-gray-50 text-gray-500 text-xs uppercase">
            <th className="px-4 py-2 font-semibold">Pos</th>
            {mostrarNombre && <th className="px-4 py-2 font-semibold">Categoría</th>}
            <th className="px-4 py-2 font-semibold">Grupo</th>
            <th className="px-4 py-2 font-semibold text-center">PJ</th>
            <th className="px-4 py-2 font-semibold text-center">PG</th>
            <th className="px-4 py-2 font-semibold text-center">PE</th>
            <th className="px-4 py-2 font-semibold text-center">PP</th>
            <th className="px-4 py-2 font-semibold text-center">GF</th>
            <th className="px-4 py-2 font-semibold text-center">GC</th>
            <th className="px-4 py-2 font-semibold text-center">DG</th>
            <th className="px-4 py-2 font-semibold text-center font-bold text-gray-900">PTS</th>
          </tr>
        </thead>
        <tbody>
          {filas.map((fila, idx) => (
            <tr key={idx} className="border-t border-gray-100 hover:bg-gray-50">
              <td className="px-4 py-3 font-semibold text-gray-500">{idx + 1}</td>
              {mostrarNombre && (
                <td className="px-4 py-3 font-semibold text-gray-900">{fila.nombre_categoria ?? "—"}</td>
              )}
              <td className="px-4 py-3 text-gray-500">{fila.grupo ?? "—"}</td>
              <td className="px-4 py-3 text-center">{fila.PJ}</td>
              <td className="px-4 py-3 text-center text-green-600">{fila.PG}</td>
              <td className="px-4 py-3 text-center text-yellow-600">{fila.PE}</td>
              <td className="px-4 py-3 text-center text-red-500">{fila.PP}</td>
              <td className="px-4 py-3 text-center">{fila.GF}</td>
              <td className="px-4 py-3 text-center">{fila.GC}</td>
              <td className={`px-4 py-3 text-center ${fila.DG > 0 ? "text-green-600" : fila.DG < 0 ? "text-red-500" : "text-gray-500"}`}>
                {fila.DG > 0 ? `+${fila.DG}` : fila.DG}
              </td>
              <td className="px-4 py-3 text-center font-bold text-blue-700">{fila.puntos}</td>
            </tr>
          ))}
          {filas.length === 0 && (
            <tr>
              <td colSpan={11} className="px-4 py-8 text-center text-gray-400">
                Sin datos de posiciones
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
